import ClosetItemsList from "@components/core/ClosetItemsList";
import ClosetHeader from "./ClosetHeader";
import ClosetAction from "./ClosetAction";
import ClosetShortReview from "./ClosetShortReview";

function ClosetLayout({ closet, reloadCloset, children }) {
  if (!closet?.id || closet?.state === "empty") return null;

  return (
    <div className="pb-4 border-bottom border-light mb-4">
      <ClosetHeader closet={closet} />
      <ClosetAction closet={closet} />
      <ClosetShortReview
        closet={closet}
        reloadCloset={reloadCloset}
        origin="history"
        className="pb-3"
      />
      <ClosetItemsList
        closet={closet}
        containerClassName="my-closets"
      />
      {children}
    </div>
  );
}

export default ClosetLayout;
